
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import PatUntersuchung from '@/types/PatUntersuchung';
    import moment from 'moment';
    import Untersuchung from '@/types/Untersuchung';
    import { ValidationRules } from '@/store/types';
    import { createAutocompleteFilter, VForm } from '@/types/Components';
    import _, {forEach} from 'lodash';
    import Dienstort from '@/types/Dienstort';

    @Component({
        computed: {
            ...mapState('globals', ['rules', 'formatDate', 'parseDate']),
            ...mapState('untersuchungen', ['loaders', 'untersuchungen']),
        },
        methods: {
            ...mapActions('untersuchungen', ['loadUntersuchungen']),
        },
    })
    export default class PlanNeueUntersuchung extends Vue {
        @Prop() visible!: boolean;

        public $refs!: {
            form: VForm;
        };

        public search = '';

        public parseDate!: (input: string | null) => string | null;
        public formatDate!: (input: string | null) => string | null;
        public loadUntersuchungen!: () => void;
        public rules!: ValidationRules;
        public untersuchungen!: Untersuchung[];

        public data = new PatUntersuchung();

        public readonly untersuchungenFilter = createAutocompleteFilter<Untersuchung>('untersuchung', 'code');

        @Watch('untersuchungen')
        public onUntersuchungenLoaded(newValue: Untersuchung[]): void {
            this.data.untersuchungen = newValue
                .filter(({ untersuchung_id, select_by_default }) => untersuchung_id != null && select_by_default === 'j')
                .map(({ untersuchung_id }) => untersuchung_id as number);
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.reset({ resetDate: true });

                this.loadUntersuchungen();
            }
        }

        public reset({ resetDate }: { resetDate: boolean }): void {

            const previousGeplant = this.data.geplant
            this.data = new PatUntersuchung();

            if (resetDate || previousGeplant == null) {
                this.data.geplant = moment().format('YYYY-MM-DD');
            } else {
                this.data.geplant = previousGeplant;
            }

            this.datumErrorMessages = [];
            this.datumFormatted = this.formatDate(this.data.geplant);

            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }

        public onClickAdd(closeDialog: boolean): void {
            if (!this.$refs.form.validate() || this.datumErrorMessages.length > 0) {
                return;
            }

            _.forEach(this.data.untersuchungen, (item: number) => {
                const untersuchung = this.untersuchungen.find(({ untersuchung_id }) => {
                    return untersuchung_id === item;
                });

                if (untersuchung) {
                    this.data.untersuchung = untersuchung.untersuchung;
                    this.data.untersuchung_id = untersuchung.untersuchung_id;
                }

                this.$emit('click:add', this.data);
                this.reset({ resetDate: false });
            });

            if (closeDialog) {
                this.$emit('close');
            } else {
                this.reset({ resetDate: true });
            }
        }

        public datumMenu = false;
        public datumFormatted: string | null = null;
        public datumErrorMessages: string[] = [];

        @Watch('data.geplant')
        public onChangeDatum(date: string | null): void {
            this.datumFormatted = this.formatDate(this.data.geplant);

            if (date !== null) {
                this.datumErrorMessages = [];

                for (const rule of [this.rules.required, this.rules.validDate]) {
                    const valid = rule(this.data.geplant);
                    if (valid !== true) {
                        this.datumErrorMessages.push(valid as string);
                    }
                }
            }
        }
    }
